import styles from "./styles/conversion-effect-card.module.scss";
import tooltipStyles from "@/components/common/styles/tooltip.module.scss";
import Switcher from "@/components/common/switcher";
import Image from "next/image";
import infoIcon from "@/assets/icons/info-icon.svg";
import { Tooltip } from "react-tooltip";

type ConversionEffectCardProps = {
  isSelected: boolean;
  isEnabled: boolean;
  handleClick: () => void;
  handleSwitcherClick: () => void;
  iconPath: string;
  title: string;
  tooltip: string;
};

const ConversionEffectCard = ({
  isSelected,
  isEnabled,
  handleClick,
  handleSwitcherClick,
  iconPath,
  title,
  tooltip,
}: ConversionEffectCardProps) => {
  return (
    <div
      className={styles.card_wrapper}
      onClick={handleClick}
      style={{ borderColor: isSelected ? "#F9A825" : "#3F3F3F" }}
    >
      <Switcher handleClick={handleSwitcherClick} isEnabled={isEnabled} />
      <Image src={iconPath} alt={title} height={32} width={32} />
      <div
        onClick={(e) => e.stopPropagation()}
        data-tooltip-id="effectTooltip"
        data-tooltip-content={tooltip}
      >
        <Image src={infoIcon} alt={tooltip} height={16} width={16} />
        <Tooltip
          className={tooltipStyles.tooltip}
          id="effectTooltip"
          place="top"
        />
      </div>
      <div className={styles.card_title}>{title}</div>
    </div>
  );
};

export default ConversionEffectCard;
